/**
 * Seasonal warehouse sale start time
 */
export const SEASONAL_WAREHOUSE_SALE_START_AT = 'SEASONAL_WAREHOUSE_SALE_START_AT';
